export default "__VITE_ASSET__CEvRVgBd__"